import { HiOutlineCheckCircle } from "react-icons/hi2";

const shimmer =
  "animate-pulse rounded-full bg-[linear-gradient(90deg,rgba(255,255,255,0.03),rgba(255,178,91,0.18),rgba(255,139,31,0.12),rgba(255,255,255,0.03))] dark:bg-[linear-gradient(90deg,rgba(255,255,255,0.04),rgba(255,178,91,0.2),rgba(229,106,0,0.14),rgba(255,255,255,0.04))]";

function Row({ width = "w-28" }) {
  return (
    <div className="flex flex-col gap-2">
      <div className={`h-2.5 w-16 ${shimmer}`}></div>
      <div className={`h-3.5 ${width} ${shimmer}`}></div>
    </div>
  );
}

const SkeletonCard = () => (
  <div className="portal-page-card grid min-h-[210px] gap-2.5 rounded-[1.35rem] p-4">
    <div className="flex items-center justify-between gap-2">
      <div className="flex items-center gap-1.5 text-xs font-bold text-emerald-400">
        <HiOutlineCheckCircle className="text-lg opacity-80" />
        <div className={`h-3.5 w-14 ${shimmer}`}></div>
      </div>
      <div className={`h-5 w-24 ${shimmer}`}></div>
    </div>

    <Row width="w-20" />
    <Row width="w-16" />
    <Row width="w-36" />
    <Row width="w-28" />
  </div>
);

const SkeletonMyOrder = ({ number = 3 }) => (
  <div className="grid">
    <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 xl:grid-cols-3">
      {Array(number)
        .fill(0)
        .map((_, index) => (
          <SkeletonCard key={index} />
        ))}
    </div>
  </div>
);

export default SkeletonMyOrder;
